import {Constant} from './constant';

export class StringUtils {


  public static capitalizeFirst(chaine: string): string {
    if (chaine != null) {
      return chaine.charAt(0).toUpperCase() + chaine.slice(1);
    }
    return null;
  }

  // méthode qui extrait des éléments dans une chaîne entre deux séparateurs
  public static extractAllBetweenSeparators(chaine: string, startSep: string, endSep: string): string[] {
    const regex = new RegExp(`${startSep}(.*?)${endSep}`, 'g');
    const matches = chaine.match(regex);
    if (!matches) return [];

    return matches.map(match => match.slice(startSep.length, -endSep.length));
  }

  public static toASCII(label = '', replacement = '') {
    return StringUtils._fold(label, () => replacement);
  }

  private static _fold(label: string, fallback): string {
    if (label === null) {
      return '';
    }

    if (typeof label === 'number') {
      return '' + label;
    }

    if (typeof label !== 'string') {
      throw new Error('Invalid input data type');
    }

    return label.split('').map(character => {
      if (character.charCodeAt(0) < 128) {
        return character;
      } else {
        const replacement = Constant.ASCII_MAPPING.get(character.charCodeAt(0));
        return (replacement === undefined) ? fallback(character) : replacement;
      }
    }).join('');
  }

}
